import React, { useContext } from 'react';
import CheckboxInput from '../../../../Components/CheckBoxInput';
import { ConfigContext } from '../../../../Contexts/ConfigContext';

import { Grid } from '@mui/material';
import useCommonStyles from '../../../../commonStyles';
import Paper from '@mui/material/Paper';
import PageHeading from '../../../../Components/PageHeading';
/**
 * @name HbOnlySetupConfig
 * @description This component serves as an editor for the `hbOnly` configuration.
 * ```
 * "hbOnly": { "enabled": true }
 * ```
 * @param {{keyData: 'networkData.hbOnly'}} keyData - The key used to identify the configuration within the `rawConfig` object.
 */

const HbOnlySetupConfig = ({ keyData,featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);

	/**
	 * @name updateHbOnlyConfig
	 * @description this function updates the value of enabled in hbOnly config 
	
	 * @param {boolean} value - The value to set for the `enabled` property in the `hbOnly` configuration.
	 */

	const updateHbOnlyConfig = (value) => {
		const clonedRawConfig = structuredClone(rawConfig);
		clonedRawConfig[keyData] = clonedRawConfig[keyData] || {};
		clonedRawConfig[keyData].enabled = value;
		updateRawConfig(clonedRawConfig);
	};

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="HB Only Setup"
				headingPath={['Dashboard', 'Framerate', 'Network Data', 'HB Only Setup']}
				description="Manage HB Only Setup Configuration"
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={2}>
				<Grid item xs={6}>
					<CheckboxInput
						keyData={keyData + '.enabled'}
						isObjectEditor={false}
						label="Enabled"
						disabled={false}
						defaultChecked={false}
						style={{ marginTop: '4rem', marginLeft: '5rem' }}
						directValue={rawConfig[keyData]?.enabled}
						updateDirectValue={(value) => updateHbOnlyConfig(value)}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default HbOnlySetupConfig;
